import { ApiCall } from "components/common/services/ApiServices";
import { SEND_WHATSAPP_MESSAGE } from "../../../../routes/ApiEndpoints";
import { AJ_WEB_CONNECTOR } from "Constants";
import type { ChatMessagePayload, WhatsAppDataProps } from "../annotations/WhatsAppAnnotations";

/**
 * Sends a WhatsApp message.
 */
export const SendMessage = async (
  whatsAppData: WhatsAppDataProps,
  payload: ChatMessagePayload
) => {
  const data = {
    to: whatsAppData.to, // Ideally this should be dynamic
    personId: whatsAppData.personId,
    name: whatsAppData.name,
    payload: payload
  };

  return await ApiCall.service(
    SEND_WHATSAPP_MESSAGE,
    "POST",
    data,
    false,
    AJ_WEB_CONNECTOR
  );
};
